module.exports = __webpack_public_path__ + "static/media/img-2.c7e3db12.png";